import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import '../styles/Auth.css';

const Register = () => {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    password: '',
    confirmPassword: ''
  });
  
  const { firstName, lastName, email, password, confirmPassword } = formData;
  
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };
  
  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    
    // Validation des mots de passe
    if (password !== confirmPassword) {
      setError('Les mots de passe ne correspondent pas');
      return;
    }
    
    try {
      setLoading(true);
      // Préparation des données à envoyer (sans confirmPassword)
      const userData = {
        firstName,
        lastName,
        email,
        password
      };
      
      // Appel au service d'inscription
      await register(userData);
      
      // Redirection vers la page de connexion après inscription réussie
      navigate('/login', { 
        state: { 
          message: 'Inscription réussie! Un email de vérification a été envoyé à votre adresse email. Veuillez vérifier votre boîte de réception et confirmer votre adresse email avant de vous connecter.', 
          email: email 
        } 
      });
    } catch (err) {
      console.error('Erreur lors de l\'inscription:', err);
      setError(err.message || 'Une erreur est survenue lors de l\'inscription');
    } finally {
      setLoading(false);
    }
  };
  
  return (
    <div className="auth-page">
      <div className="container">
        <div className="auth-container">
          <div className="auth-card">
            <h2 className="auth-title">S'inscrire</h2>
            <p className="auth-subtitle">Créez votre profil explorez RQM</p>
            
            <form className="auth-form" onSubmit={handleSubmit}>
              <div className="form-row">
                <div className="form-group">
                  <label htmlFor="firstName" className="form-label">Prénom*</label>
                  <input
                    type="text"
                    id="firstName"
                    name="firstName"
                    className="form-control"
                    value={firstName}
                    onChange={handleChange}
                    required
                  />
                </div>
                
                <div className="form-group">
                  <label htmlFor="lastName" className="form-label">Nom*</label>
                  <input
                    type="text"
                    id="lastName"
                    name="lastName"
                    className="form-control"
                    value={lastName}
                    onChange={handleChange}
                    required
                  />
                </div>
              </div>
              
              <div className="form-group">
                <label htmlFor="email" className="form-label">Courriel*</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  className="form-control"
                  value={email}
                  onChange={handleChange}
                  required
                />
              </div>
              
              <div className="form-group">
                <label htmlFor="password" className="form-label">Mot de passe*</label>
                <input
                  type="password"
                  id="password"
                  name="password"
                  className="form-control"
                  value={password}
                  onChange={handleChange}
                  required
                  minLength="6"
                />
                <small className="form-text">Le mot de passe doit contenir au moins 6 caractères</small>
              </div>
              
              <div className="form-group">
                <label htmlFor="confirmPassword" className="form-label">Confirmer le mot de passe*</label>
                <input
                  type="password"
                  id="confirmPassword"
                  name="confirmPassword"
                  className="form-control"
                  value={confirmPassword}
                  onChange={handleChange}
                  required
                  minLength="6"
                />
              </div>
              
              <div className="form-group">
                <small className="form-text">
                  En vous inscrivant, vous acceptez les <Link target="_blank" to="/terms">conditions d'utilisation</Link> et la <Link target="_blank" to="/privacy">politique de confidentialité</Link>.
                  <br />
                  Un email de vérification vous sera envoyé après l'inscription. Vous devrez confirmer votre adresse email avant de pouvoir vous connecter.
                </small>
              </div>
              
              {error && (
                <div className="alert alert-danger">
                  {error}
                </div>
              )}
              
              <button 
                type="submit" 
                className="btn btn-primary btn-block"
                disabled={loading}
              >
                {loading ? 'Inscription en cours...' : 'S\'inscrire'}
              </button>
            </form>
            
            <div className="auth-footer">
              <p>
                Vous avez déjà un compte?{' '}
                <Link to="/login" className="auth-link">
                  Se connecter
                </Link>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Register;
